import { MATRIX_CALCIUM, TOTAL_MATRIX_CALCIUM, DIG_PHOSPHORUS } from './application';

export const mean = (data) => {
  return {
    "Intercept": 1,
    "Total Ca, %": data['totalCa'],
    "Phytase dose, FYT/kg": data['dose'],
    "Phytate P, %": data['phytate'],
    "Phytate P, %*Phytate P, %": data['phytate'] * data['phytate'],
    "Phytate P, %*Total Ca, %": data['phytate'] * data['totalCa'],
    "Phytate P, %*Total Ca, %*Total Ca, %": data['phytate'] * data['totalCa'] * data['totalCa'],
    "Limestone solubility (%), 15 min": data['totalSolubility'],
    "Limestone mean particle size, mm": data['particleSize'],
    "Limestone solubility (%), 15 min*Limestone mean particle size, mm": data['totalSolubility'] * data['particleSize'],
  }
}


export const resultForCalcium = (data) => {
  const resultMean = mean(data);
  
  return MATRIX_CALCIUM['Intercept']
    + MATRIX_CALCIUM['Limestone solubility, 15 min'] * resultMean['Limestone solubility (%), 15 min']
    + MATRIX_CALCIUM['Limestone solubility, 15 min*Limestone solubility, 15 min'] * resultMean['Limestone solubility (%), 15 min'] * resultMean['Limestone solubility (%), 15 min']
    + MATRIX_CALCIUM['Total Ca, %'] * resultMean['Total Ca, %']
    + MATRIX_CALCIUM['Total Ca, %*Total Ca, %'] * resultMean['Total Ca, %'] * resultMean['Total Ca, %']
    + MATRIX_CALCIUM['Ln phytase'] * Math.log(resultMean['Phytase dose, FYT/kg'])
    + MATRIX_CALCIUM['Particle size, mm'] * resultMean['Limestone mean particle size, mm']
    + MATRIX_CALCIUM['Limestone solubility, 15 min*Particle size, mm'] * resultMean['Limestone solubility (%), 15 min*Limestone mean particle size, mm']
    + MATRIX_CALCIUM['Age'] * MATRIX_CALCIUM['Age, days']
    + MATRIX_CALCIUM['Phytate P, %'] * resultMean['Phytate P, %']
    + MATRIX_CALCIUM['Phytate P, %*Phytate P, %'] * resultMean['Phytate P, %*Phytate P, %']
    + resultMean['Phytate P, %*Total Ca, %'] * MATRIX_CALCIUM['Total Ca, %*Phytate P, %']
    + resultMean['Phytate P, %*Total Ca, %*Total Ca, %'] * MATRIX_CALCIUM['Total Ca, %*Total Ca, %*Phytate P, %']
  };
  
  export const constValue = () => {
    return (TOTAL_MATRIX_CALCIUM['first'] + TOTAL_MATRIX_CALCIUM['second']) / 2;
  }
  
  export const digPmean = (data) => {
    return {
      "Total Ca, %": data['totalCa'],
      "Phytase dose, FYT/kg": data['dose'],
      "Phytate P, %": data['phytate'],
      "Phytate P, %*Phytate P, %": data['phytate'] * data['phytate'],
      "Phytate P, %*Total Ca, %": data['phytate'] * data['totalCa'],
      "Phytate P, %*Total Ca, %*Total Ca, %": data['phytate'] * data['totalCa'] * data['totalCa'],
      "Limestone solubility (%), 15 min": data['totalSolubility'],
      "Limestone mean particle size, mm": data['particleSize'],
      "Limestone solubility (%), 15 min*Limestone mean particle size, mm": data['totalSolubility'] * data['particleSize'],
    }
  }
  
  export const resultForPhosphorus = (data) => {
    const resultMean = digPmean(data);
    
    return DIG_PHOSPHORUS['Intercept']
    + DIG_PHOSPHORUS['Log phytase'] * Math.log(resultMean['Phytase dose, FYT/kg'])
    + DIG_PHOSPHORUS['Total Ca, %'] * resultMean['Total Ca, %']
    + DIG_PHOSPHORUS['Phytate P, %'] * resultMean['Phytate P, %']
    + DIG_PHOSPHORUS['Total Ca, %*Total Ca, %'] * resultMean['Total Ca, %'] * resultMean['Total Ca, %']
    + DIG_PHOSPHORUS['Limestone solubility, 15 min'] * resultMean['Limestone solubility (%), 15 min']
    + DIG_PHOSPHORUS['Phytate P, %*Log phytase'] * Math.log(resultMean['Phytase dose, FYT/kg']) * resultMean['Phytate P, %']
    + DIG_PHOSPHORUS['Age'] * DIG_PHOSPHORUS['Age, days']
};
